import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');

export function getAllProjects(env) {
    return (dispatch, getState) => {
        const groupId = getState().environments[env].gitlabApi.get('groupId');
        return apiCaller
            .call(api.getAllProjects(env, groupId))
            .then(({ data }) => {
                let projects = {};
                data.forEach(({ id, name }) => {
                    projects[id] = { name };
                });
                dispatch({
                    type: `${env.toUpperCase()}_GIT__SET_PROJECTS`,
                    projects
                });
                return data;
            })
            .catch(error => {
                Logger.error('dataActions: getAllTicketsGit - ', error);
                throw error;
            });
    };
}
export function getProject(env, projectId) {
    return dispatch => {
        return apiCaller
            .call(api.getProject(env, projectId))
            .then(({ data }) => {
                if (data) {
                    const { id, name } = data;
                    const project = { [id]: { name } };
                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_PROJECT`,
                        project
                    });
                    return data;
                } else throw new Error('project_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getProject - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Projects/actions.js